import $ from 'jquery';
import abgrcs_config from './abgrcs_config.js';

function About() {
  return [
    <div class="row justify-content-center">
      <div class="col-md-7">
        <div class="row mb-5">
          <div class="col-12 ">
            <h2 class="site-section-heading text-center">My Services</h2>
          </div>
        </div>
      </div>
    </div>,
    <div class="row mb-5">
      <div class="col-md-7">
        <img src="uploads/img_2.jpg" alt="Images" class="img-fluid" />
      </div>
      <div class="col-md-4 ml-auto">
        <h3 class="text-white">My Mission</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus vel tenetur explicabo necessitatibus, ad soluta consectetur illo qui voluptatem. Quis soluta maiores eum. Iste modi voluptatum in repudiandae fugiat suscipit dolorum harum, porro voluptate quis? Alias repudiandae dicta doloremque voluptates soluta repellendus, unde laborum quo nam, ullam facere voluptatem similique.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolor architecto excepturi aliquid minus nostrum dicta labore iusto obcaecati fugit cupiditate.</p>
      </div>
    </div>,
    <div class="row site-section">
      <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5">
        <img src="uploads/person_1.jpg" alt="Image" class="img-fluid w-50 rounded-circle mb-4" />
        <h2 class="text-black font-weight-light mb-4">Jean Smith</h2>
        <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur ab quas facilis obcaecati non ea, est odit repellat distinctio incidunt, quia aliquam eveniet quod deleniti impedit sapiente atque tenetur porro?</p>
        <p>
        <a href="#" class="pl-0 pr-3"><span class="icon-twitter"></span></a>
        <a href="#" class="pl-3 pr-3"><span class="icon-instagram"></span></a>
        <a href="#" class="pl-3 pr-3"><span class="icon-facebook"></span></a>
        </p>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5">
        <img src="uploads/person_2.jpg" alt="Image" class="img-fluid w-50 rounded-circle mb-4" />
        <h2 class="text-black font-weight-light mb-4">Claire Smith</h2>
        <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur ab quas facilis obcaecati non ea, est odit repellat distinctio incidunt, quia aliquam eveniet quod deleniti impedit sapiente atque tenetur porro?</p>
        <p>
        <a href="#" class="pl-0 pr-3"><span class="icon-twitter"></span></a>
        <a href="#" class="pl-3 pr-3"><span class="icon-instagram"></span></a>
        <a href="#" class="pl-3 pr-3"><span class="icon-facebook"></span></a>
        </p>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5">
        <img src="uploads/person_4.jpg" alt="Image" class="img-fluid w-50 rounded-circle mb-4" />
        <h2 class="text-black font-weight-light mb-4">John Smith</h2>
        <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur ab quas facilis obcaecati non ea, est odit repellat distinctio incidunt, quia aliquam eveniet quod deleniti impedit sapiente atque tenetur porro?</p>
        <p>
        <a href="#" class="pl-0 pr-3"><span class="icon-twitter"></span></a>
        <a href="#" class="pl-3 pr-3"><span class="icon-instagram"></span></a>
        <a href="#" class="pl-3 pr-3"><span class="icon-facebook"></span></a>
        </p>
      </div>
    </div>
  ];
}

export default About;